const KEY = "paw_favs";
export const getFavs = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };
export const isFav = (id) => getFavs().includes(id);
export const toggleFav = (id) => {
  const f = getFavs();
  const n = f.includes(id) ? f.filter((x) => x !== id) : [...f, id];
  localStorage.setItem(KEY, JSON.stringify(n));
  return n;
};
